import { render } from "./WCModalBody.vue?vue&type=template&id=6742f9ba"
import script from "./WCModalBody.vue?vue&type=script&lang=js"
export * from "./WCModalBody.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__